import {Hub} from 'yougile-model'
import {parseDateTime, Time} from 'yougile-util'
import {COLUMN_NAMES} from '../../constants'
import {Row, State} from '../../types'
import {addToCheckProcessedColumn} from '../utils/add-to-check-processed-column'
import {getRowValue} from '../utils/get-row-value'

export const processArchived = (state: State, row: Row, task: Hub): void => {
  const taskArchived = getRowValue(state, row, COLUMN_NAMES.ARCHIVED)
  if (taskArchived) {
    addToCheckProcessedColumn(state, COLUMN_NAMES.ARCHIVED)
    task.complete = parseDateTime(taskArchived) || Time.now()
  }
}
